<template>
  <!-- Kontener filtra z nazwą i selectem -->
  <div class="filter">
    <!-- Nazwa filtra, np. "Sortuj wg". Usuwa dolną ramkę na kroku 3 -->
    <div class="name" :class="{ 'no-border': step === 3 }">{{ name }} </div>
    <!-- Select z opcjami filtrowania/sortowania -->
    <div class="select" :class="{ 'no-border': step === 3 }">
      <select class="form-select" :name="fieldName" v-model.lazy="value">
        <!-- 
          Generowanie opcji selecta na podstawie typu:
            - Jeśli type === 'direction', to bierzemy store.directionColumns
            - W przeciwnym razie store.orderByColumns
        -->
        <option
          v-for="(option, index) in type === 'direction' 
            ? store.directionColumns 
            : store.orderByColumns"
          :key="index"
          :value="index"
        >
          {{ t(option) }} <!-- Przetłumaczona wartość opcji -->
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { watch, ref } from "vue";

export default {
  name: "SelectFilter",
  props: {
    name: String,         // Nazwa filtra (tekst widoczny obok selecta)
    fieldName: String,    // Nazwa pola w store.filters (np. "orderByColumn")
    type: String,         // Typ selecta (np. "direction" lub domyślny)
    store: Object,        // Obiekt store Pinia z metodą addItem i filters
    selected: {           // Wartość początkowa filtra
      type: [String, Number],
      default: ''
    },
    step: {               // Aktualny krok w wieloetapowym formularzu
      type: Number,
      default: 1
    }
  },
  setup(props) {
    // Lokalny stan value, inicjalizowany na podstawie wartości w store.filters
    const value = ref(
      props.store.filters[props.fieldName]
        ? props.store.filters[props.fieldName]
        : ""
    );

    // Funkcja zapisująca wartość selecta do store.filters
    const saveValue = (text) => {
      props.store.addItem(props.fieldName, text);
    };

    // Watcher: przy zmianie value, wywołuje zapis do store
    watch(value, (newValue) => {
      saveValue(newValue);
    });

    // Eksportujemy value do template (v-model na select)
    return { value };
  },
};
</script>

<style scoped>
/* Nazwa filtra */
.name {
  padding: 17px 0 16px 16px;
  font-size: 16px;
  background-color: white;
}

/* Select oraz obudowa */
.select {
  height: 47px;
}

/* Usunięcie dolnej ramki na kroku 3 */
.name.no-border,
.select.no-border {
  border-bottom: none !important;
}

/* Styl selecta */
.form-select {
  max-width: 275px;
}


</style>